import { render, staticRenderFns } from "./CategorizeModal.vue?vue&type=template&id=0c7de170&scoped=true&"
import script from "./CategorizeModal.vue?vue&type=script&lang=js&"
export * from "./CategorizeModal.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/categorize_modal.scss?vue&type=style&index=0&id=0c7de170&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7de170",
  null
  
)

export default component.exports